// @ts-nocheck
import {
  createIntl,
  IntlShape,
  MessageDescriptor,
} from 'D:/a/1/s/node_modules/react-intl';
import { ApplyPluginsType } from 'umi';
import { event, LANG_CHANGE_EVENT } from './locale';
// @ts-ignore
import warning from 'D:/a/1/s/node_modules/warning/warning.js';

import { plugin } from '../core/plugin';

export {
  createIntl,
};
export {
  FormattedDate,
  FormattedDateParts,
  FormattedDisplayName,
  FormattedHTMLMessage,
  FormattedList,
  FormattedMessage,
  FormattedNumber,
  FormattedNumberParts,
  FormattedPlural,
  FormattedRelativeTime,
  FormattedTime,
  FormattedTimeParts,
  IntlContext,
  IntlProvider,
  RawIntlProvider,
  createIntlCache,
  defineMessages,
  injectIntl,
  useIntl,
} from 'D:/a/1/s/node_modules/react-intl';

let g_intl: IntlShape;

const useLocalStorage = true;

import enUS0 from 'antd/es/locale/en_US';
import lang_enUS0 from "D:/a/1/s/src/locales/en-US.js";
import lang_enUS1 from "D:/a/1/s/src/pages/administration-agents/locales/en-US.js";
import lang_enUS2 from "D:/a/1/s/src/pages/administration-reports/locales/en-US.js";
import lang_enUS3 from "D:/a/1/s/src/pages/Administration/locales/en-US.js";
import lang_enUS4 from "D:/a/1/s/src/pages/api-connection-group/locales/en-US.js";
import lang_enUS5 from "D:/a/1/s/src/pages/applications/locales/en-US.js";
import lang_enUS6 from "D:/a/1/s/src/pages/approvers/locales/en-US.js";
import lang_enUS7 from "D:/a/1/s/src/pages/CompanyPortal/locales/en-US.js";
import lang_enUS8 from "D:/a/1/s/src/pages/configurations/access-log/locales/en-US.js";
import lang_enUS9 from "D:/a/1/s/src/pages/configurations/ai-consumptions/locales/en-US.js";
import lang_enUS10 from "D:/a/1/s/src/pages/configurations/areas/locales/en-US.js";
import lang_enUS11 from "D:/a/1/s/src/pages/configurations/EmailMessageTraces/locales/en-US.js";
import lang_enUS12 from "D:/a/1/s/src/pages/configurations/positions/locales/en-US.js";
import lang_enUS13 from "D:/a/1/s/src/pages/configurations/process-group/locales/en-US.js";
import lang_enUS14 from "D:/a/1/s/src/pages/configurations/process-portal/locales/en-US.js";
import lang_enUS15 from "D:/a/1/s/src/pages/configurations/shortened-urls/locales/en-US.js";
import lang_enUS16 from "D:/a/1/s/src/pages/configurations/traces/locales/en-US.js";
import lang_enUS17 from "D:/a/1/s/src/pages/configurations/users/locales/en-US.js";
import lang_enUS18 from "D:/a/1/s/src/pages/connections/locales/en-US.js";
import lang_enUS19 from "D:/a/1/s/src/pages/custom-list-groups/locales/en-US.js";
import lang_enUS20 from "D:/a/1/s/src/pages/delegations/configurations/locales/en-US.js";
import lang_enUS21 from "D:/a/1/s/src/pages/delegations/delegated-task/locales/en-US.js";
import lang_enUS22 from "D:/a/1/s/src/pages/delegations/locales/en-US.js";
import lang_enUS23 from "D:/a/1/s/src/pages/dynamic-entity-groups/locales/en-US.js";
import lang_enUS24 from "D:/a/1/s/src/pages/Entities/locales/en-US.js";
import lang_enUS25 from "D:/a/1/s/src/pages/environments/locales/en-US.js";
import lang_enUS26 from "D:/a/1/s/src/pages/External/locales/en-US.js";
import lang_enUS27 from "D:/a/1/s/src/pages/ExtraUserFields/locales/en-US.js";
import lang_enUS28 from "D:/a/1/s/src/pages/lists/locales/en-US.js";
import lang_enUS29 from "D:/a/1/s/src/pages/Overview/locales/en-US.js";
import lang_enUS30 from "D:/a/1/s/src/pages/Process/locales/en-US.js";
import lang_enUS31 from "D:/a/1/s/src/pages/Process/process-config/actions/config/api-call-response/locales/en-US.js";
import lang_enUS32 from "D:/a/1/s/src/pages/Process/process-config/actions/config/conditional/locales/en-US.js";
import lang_enUS33 from "D:/a/1/s/src/pages/Process/process-config/actions/config/custom-notifications/locales/en-US.js";
import lang_enUS34 from "D:/a/1/s/src/pages/Process/process-config/actions/config/email-template/locales/en-US.js";
import lang_enUS35 from "D:/a/1/s/src/pages/Process/process-config/actions/config/filter-by-external-users/locales/en-US.js";
import lang_enUS36 from "D:/a/1/s/src/pages/Process/process-config/actions/config/notification-attachment-mapping/locales/en-US.js";
import lang_enUS37 from "D:/a/1/s/src/pages/Process/process-config/actions/locales/en-US.js";
import lang_enUS38 from "D:/a/1/s/src/pages/Process/process-config/custom-list/locales/en-US.js";
import lang_enUS39 from "D:/a/1/s/src/pages/reports/locales/en-US.js";
import lang_enUS40 from "D:/a/1/s/src/pages/Sequence/locales/en-US.js";
import lang_enUS41 from "D:/a/1/s/src/pages/servers/locales/en-US.js";
import lang_enUS42 from "D:/a/1/s/src/pages/tasks/locales/en-US.js";
import lang_enUS43 from "D:/a/1/s/src/pages/tokens/locales/en-US.js";
import lang_enUS44 from "D:/a/1/s/src/pages/user/locales/en-US.js";
import lang_enUS45 from "D:/a/1/s/src/pages/users-groups/locales/en-US.js";
import esES0 from 'antd/es/locale/es_ES';
import lang_esES0 from "D:/a/1/s/src/locales/es-ES.js";
import lang_esES1 from "D:/a/1/s/src/pages/administration-agents/locales/es-ES.js";
import lang_esES2 from "D:/a/1/s/src/pages/administration-reports/locales/es-ES.js";
import lang_esES3 from "D:/a/1/s/src/pages/Administration/locales/es-ES.js";
import lang_esES4 from "D:/a/1/s/src/pages/api-connection-group/locales/es-ES.js";
import lang_esES5 from "D:/a/1/s/src/pages/applications/locales/es-ES.js";
import lang_esES6 from "D:/a/1/s/src/pages/approvers/locales/es-ES.js";
import lang_esES7 from "D:/a/1/s/src/pages/certificates/locales/es-ES.js";
import lang_esES8 from "D:/a/1/s/src/pages/CompanyPortal/locales/es-ES.js";
import lang_esES9 from "D:/a/1/s/src/pages/configurations/access-log/locales/es-ES.js";
import lang_esES10 from "D:/a/1/s/src/pages/configurations/ai-consumptions/locales/es-ES.js";
import lang_esES11 from "D:/a/1/s/src/pages/configurations/areas/locales/es-ES.js";
import lang_esES12 from "D:/a/1/s/src/pages/configurations/EmailMessageTraces/locales/es-ES.js";
import lang_esES13 from "D:/a/1/s/src/pages/configurations/positions/locales/es-ES.js";
import lang_esES14 from "D:/a/1/s/src/pages/configurations/process-group/locales/es-ES.js";
import lang_esES15 from "D:/a/1/s/src/pages/configurations/process-portal/locales/es-ES.js";
import lang_esES16 from "D:/a/1/s/src/pages/configurations/reports/manage-reports/locales/es-ES.js";
import lang_esES17 from "D:/a/1/s/src/pages/configurations/shortened-urls/locales/es-ES.js";
import lang_esES18 from "D:/a/1/s/src/pages/configurations/traces/locales/es-ES.js";
import lang_esES19 from "D:/a/1/s/src/pages/configurations/users/locales/es-ES.js";
import lang_esES20 from "D:/a/1/s/src/pages/connections/locales/es-ES.js";
import lang_esES21 from "D:/a/1/s/src/pages/custom-list-groups/locales/es-ES.js";
import lang_esES22 from "D:/a/1/s/src/pages/delegations/configurations/locales/es-ES.js";
import lang_esES23 from "D:/a/1/s/src/pages/delegations/delegated-task/locales/es-ES.js";
import lang_esES24 from "D:/a/1/s/src/pages/delegations/locales/es-ES.js";
import lang_esES25 from "D:/a/1/s/src/pages/dynamic-entity-groups/locales/es-ES.js";
import lang_esES26 from "D:/a/1/s/src/pages/emails/locales/es-ES.js";
import lang_esES27 from "D:/a/1/s/src/pages/Entities/locales/es-ES.js";
import lang_esES28 from "D:/a/1/s/src/pages/environments/locales/es-ES.js";
import lang_esES29 from "D:/a/1/s/src/pages/External/locales/es-ES.js";
import lang_esES30 from "D:/a/1/s/src/pages/ExtraUserFields/locales/es-ES.js";
import lang_esES31 from "D:/a/1/s/src/pages/lists/locales/es-ES.js";
import lang_esES32 from "D:/a/1/s/src/pages/Overview/locales/es-ES.js";
import lang_esES33 from "D:/a/1/s/src/pages/Process/locales/es-ES.js";
import lang_esES34 from "D:/a/1/s/src/pages/Process/process-config/actions/config/api-call-response/locales/es-ES.js";
import lang_esES35 from "D:/a/1/s/src/pages/Process/process-config/actions/config/api-call-send/locales/es-ES.js";
import lang_esES36 from "D:/a/1/s/src/pages/Process/process-config/actions/config/conditional/locales/es-ES.js";
import lang_esES37 from "D:/a/1/s/src/pages/Process/process-config/actions/config/custom-notifications/locales/es-ES.js";
import lang_esES38 from "D:/a/1/s/src/pages/Process/process-config/actions/config/digital-signature-field-mapping/locales/es-ES.js";
import lang_esES39 from "D:/a/1/s/src/pages/Process/process-config/actions/config/email-template/locales/es-ES.js";
import lang_esES40 from "D:/a/1/s/src/pages/Process/process-config/actions/config/filter-by-external-users/locales/es-ES.js";
import lang_esES41 from "D:/a/1/s/src/pages/Process/process-config/actions/config/notification-attachment-mapping/locales/es-ES.js";
import lang_esES42 from "D:/a/1/s/src/pages/Process/process-config/actions/config/pdf-template-generation-mapping/locales/es-ES.js";
import lang_esES43 from "D:/a/1/s/src/pages/Process/process-config/actions/config/response-status/locales/es-ES.js";
import lang_esES44 from "D:/a/1/s/src/pages/Process/process-config/actions/config/set-form-field-value/locales/es-ES.js";
import lang_esES45 from "D:/a/1/s/src/pages/Process/process-config/actions/config/set-variable/locales/es-ES.js";
import lang_esES46 from "D:/a/1/s/src/pages/Process/process-config/actions/config/webhook-mapping/locales/es-ES.js";
import lang_esES47 from "D:/a/1/s/src/pages/Process/process-config/actions/locales/es-ES.js";
import lang_esES48 from "D:/a/1/s/src/pages/Process/process-config/custom-list/locales/es-ES.js";
import lang_esES49 from "D:/a/1/s/src/pages/Process/process-config/emails/locales/es-ES.js";
import lang_esES50 from "D:/a/1/s/src/pages/Process/process-config/form/locales/es-ES.js";
import lang_esES51 from "D:/a/1/s/src/pages/Process/process-config/manage-notification/locales/es-ES.js";
import lang_esES52 from "D:/a/1/s/src/pages/Process/process-config/pdf-template/locales/es-ES.js";
import lang_esES53 from "D:/a/1/s/src/pages/Process/process-config/variables/locales/es-ES.js";
import lang_esES54 from "D:/a/1/s/src/pages/reports/locales/es-ES.js";
import lang_esES55 from "D:/a/1/s/src/pages/Sequence/locales/es-ES.js";
import lang_esES56 from "D:/a/1/s/src/pages/servers/locales/es-ES.js";
import lang_esES57 from "D:/a/1/s/src/pages/tasks/locales/es-ES.js";
import lang_esES58 from "D:/a/1/s/src/pages/tokens/locales/es-ES.js";
import lang_esES59 from "D:/a/1/s/src/pages/user/locales/es-ES.js";
import lang_esES60 from "D:/a/1/s/src/pages/users-groups/locales/es-ES.js";

export const localeInfo: {[key: string]: any} = {
  'en-US': {
    messages: {
      ...lang_enUS0,...lang_enUS1,...lang_enUS2,...lang_enUS3,...lang_enUS4,...lang_enUS5,...lang_enUS6,...lang_enUS7,...lang_enUS8,...lang_enUS9,...lang_enUS10,...lang_enUS11,...lang_enUS12,...lang_enUS13,...lang_enUS14,...lang_enUS15,...lang_enUS16,...lang_enUS17,...lang_enUS18,...lang_enUS19,...lang_enUS20,...lang_enUS21,...lang_enUS22,...lang_enUS23,...lang_enUS24,...lang_enUS25,...lang_enUS26,...lang_enUS27,...lang_enUS28,...lang_enUS29,...lang_enUS30,...lang_enUS31,...lang_enUS32,...lang_enUS33,...lang_enUS34,...lang_enUS35,...lang_enUS36,...lang_enUS37,...lang_enUS38,...lang_enUS39,...lang_enUS40,...lang_enUS41,...lang_enUS42,...lang_enUS43,...lang_enUS44,...lang_enUS45,
    },
    locale: 'en-US',
    antd: {
      ...enUS0,
    },
    momentLocale: '',
  },
  'es-ES': {
    messages: {
      ...lang_esES0,...lang_esES1,...lang_esES2,...lang_esES3,...lang_esES4,...lang_esES5,...lang_esES6,...lang_esES7,...lang_esES8,...lang_esES9,...lang_esES10,...lang_esES11,...lang_esES12,...lang_esES13,...lang_esES14,...lang_esES15,...lang_esES16,...lang_esES17,...lang_esES18,...lang_esES19,...lang_esES20,...lang_esES21,...lang_esES22,...lang_esES23,...lang_esES24,...lang_esES25,...lang_esES26,...lang_esES27,...lang_esES28,...lang_esES29,...lang_esES30,...lang_esES31,...lang_esES32,...lang_esES33,...lang_esES34,...lang_esES35,...lang_esES36,...lang_esES37,...lang_esES38,...lang_esES39,...lang_esES40,...lang_esES41,...lang_esES42,...lang_esES43,...lang_esES44,...lang_esES45,...lang_esES46,...lang_esES47,...lang_esES48,...lang_esES49,...lang_esES50,...lang_esES51,...lang_esES52,...lang_esES53,...lang_esES54,...lang_esES55,...lang_esES56,...lang_esES57,...lang_esES58,...lang_esES59,...lang_esES60,
    },
    locale: 'es-ES',
    antd: {
      ...esES0,
    },
    momentLocale: 'es',
  },
};

/**
 * 增加一个新的国际化语言
 * @param name 语言的 key
 * @param messages 对应的枚举对象
 * @param extraLocale momentLocale, antd 国际化
 */
export const addLocale = (
  name: string,
  messages: Object,
  extraLocales: {
    momentLocale:string;
    antd:string
  },
) => {
  if (!name) {
    return;
  }
  // 可以合并
  const mergeMessages = localeInfo[name]?.messages
    ? Object.assign({}, localeInfo[name].messages, messages)
    : messages;


  const { momentLocale, antd } = extraLocales || {};
  const locale = name.split('-')?.join('-')
  localeInfo[name] = {
    messages: mergeMessages,
    locale,
    momentLocale: momentLocale,
    antd,
  };
   // 如果这是的 name 和当前的locale 相同需要重新设置一下，不然更新不了
  if (locale === getLocale()) {
    event.emit(LANG_CHANGE_EVENT, locale);
  }
};

/**
 * 获取当前的 intl 对象，可以在 node 中使用
 * @param locale 需要切换的语言类型
 * @param changeIntl 是否不使用 g_intl
 * @returns IntlShape
 */
export const getIntl = (locale?: string, changeIntl?: boolean) => {
  // 如果全局的 g_intl 存在，且不是 setIntl 调用
  if (g_intl && !changeIntl && !locale) {
    return g_intl;
  }
  // 如果存在于 localeInfo 中
  if (locale&&localeInfo[locale]) {
    return createIntl(localeInfo[locale]);
  }
  // 不存在需要一个报错提醒
  warning(
    !locale||!!localeInfo[locale],
    `The current popular language does not exist, please check the locales folder!`,
  );
  // 使用 zh-CN
  if (localeInfo["es-ES"]) return createIntl(localeInfo["es-ES"]);

  // 如果还没有，返回一个空的
  return createIntl({
    locale: "es-ES",
    messages: {},
  });
};

/**
 * 切换全局的 intl 的设置
 * @param locale 语言的key
 */
export const setIntl = (locale: string) => {
  g_intl = getIntl(locale, true);
};

/**
 * 获取当前选择的语言
 * @returns string
 */
export const getLocale = () => {
  const runtimeLocale = plugin.applyPlugins({
    key: 'locale',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  // runtime getLocale for user define
  if (typeof runtimeLocale?.getLocale === 'function') {
    return runtimeLocale.getLocale();
  }
  // please clear localStorage if you change the baseSeparator config
  // because changing will break the app
  const lang =
    navigator.cookieEnabled && typeof localStorage !== 'undefined' && useLocalStorage
      ? window.localStorage.getItem('umi_locale')
      : '';
  // support baseNavigator, default true
  let browserLang;
  const isNavigatorLanguageValid =
    typeof navigator !== 'undefined' && typeof navigator.language === 'string';
  browserLang = isNavigatorLanguageValid
    ? navigator.language.split('-').join('-')
    : '';
  return lang || browserLang || "es-ES";
};


/**
 * 获取当前选择的方向
 * @returns string
 */
export const getDirection = () => {
  const lang = getLocale();
  // array with all prefixs for rtl langueges ex: ar-EG , he-IL
  const rtlLangs = ['he', 'ar', 'fa', 'ku']
  const direction =  rtlLangs.filter(lng => lang.startsWith(lng)).length ? 'rtl' : 'ltr';
  return direction;
};

/**
 * 切换语言
 * @param lang 语言的 key
 * @param realReload 是否刷新页面，默认刷新
 * @returns string
 */
export const setLocale = (lang: string, realReload: boolean = true) => {
  const runtimeLocale = plugin.applyPlugins({
    key: 'locale',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });

  const updater = () => {
    if (getLocale() !== lang) {
      if (navigator.cookieEnabled && typeof window.localStorage !== 'undefined' && useLocalStorage) {
        window.localStorage.setItem('umi_locale', lang || '');
      }
      setIntl(lang);
      if (realReload) {
        window.location.reload();
      } else {
        event.emit(LANG_CHANGE_EVENT, lang);
        // chrome 不支持这个事件。所以人肉触发一下
        if (window.dispatchEvent) {
          const event = new Event('languagechange');
          window.dispatchEvent(event);
        }
      }
    }
  }

  if (typeof runtimeLocale?.setLocale === 'function') {
    runtimeLocale.setLocale({
      lang,
      realReload,
      updater: updater,
    });
    return;
  }

  updater();
};

let firstWaring = true;

/**
 * intl.formatMessage 的语法糖
 * @deprecated 使用此 api 会造成切换语言的时候无法自动刷新，请使用 useIntl 或 injectIntl
 * @param descriptor { id : string, defaultMessage : string }
 * @param values { [key:string] : string }
 * @returns string
 */
export const formatMessage: IntlShape['formatMessage'] = (
  descriptor: MessageDescriptor,
  values: any,
) => {
  if (firstWaring) {
    warning(
      false,
      `Using this API will cause automatic refresh when switching languages, please use useIntl or injectIntl.

使用此 api 会造成切换语言的时候无法自动刷新，请使用 useIntl 或 injectIntl。

http://j.mp/37Fkd5Q
      `,
    );
    firstWaring = false;
  }
  return g_intl.formatMessage(descriptor, values);
};

/**
 * 获取语言列表
 * @returns string[]
 */
export const getAllLocales = () => Object.keys(localeInfo);
